import _ from 'lodash';

import {
  RESCHEDULE_TEACHER_RESERVATION_LOADING,
  RESCHEDULE_TEACHER_RESERVATION_SUCCESS,
  RESCHEDULE_TEACHER_RESERVATION_ERROR,
  CANCEL_TEACHER_BOOKING_LOADING,
  CANCEL_TEACHER_BOOKING_SUCCESS,
  CANCEL_TEACHER_BOOKING_ERROR
} from 'actions/Teacher/reservationActions';

import {
  TEACHER_AVAILABILITY_LOADING,
  TEACHER_AVAILABILITY_SUCCESS,
  TEACHER_AVAILABILITY_ERROR,
  SET_TEACHER_AVAILABILITY_LOADING,
  SET_TEACHER_AVAILABILITY_SUCCESS,
  SET_TEACHER_AVAILABILITY_ERROR,
  GET_TEACHER_BLOCKS_LOADING,
  GET_TEACHER_BLOCKS_SUCCESS,
  GET_TEACHER_BLOCKS_ERROR,
  GET_TEACHER_CREATED_BLOCKS_LOADING,
  GET_TEACHER_CREATED_BLOCKS_SUCCESS,
  GET_TEACHER_CREATED_BLOCKS_ERROR,
  GET_CALENDAR_CREATED_BLOCKS_LOADING,
  GET_CALENDAR_CREATED_BLOCKS_SUCCESS,
  GET_CALENDAR_CREATED_BLOCKS_ERROR,
  CREATE_TEACHER_BLOCK_LOADING,
  CREATE_TEACHER_BLOCK_SUCCESS,
  CREATE_TEACHER_BLOCK_ERROR,
  UPDATE_TEACHER_BLOCK_LOADING,
  UPDATE_TEACHER_BLOCK_SUCCESS,
  UPDATE_TEACHER_BLOCK_ERROR,
  DELETE_TEACHER_BLOCK_LOADING,
  DELETE_TEACHER_BLOCK_SUCCESS,
  DELETE_TEACHER_BLOCK_ERROR
} from 'actions/Teacher/availabilityActions';

import {
  GET_TEACHER_LISTINGS_LOADING,
  GET_TEACHER_LISTINGS_SUCCESS,
  GET_TEACHER_LISTINGS_ERROR,
  GET_TEACHER_LISTING_LOADING,
  GET_TEACHER_LISTING_SUCCESS,
  GET_TEACHER_LISTING_ERROR,
  UPDATE_TEACHER_LISTING_LOADING,
  UPDATE_TEACHER_LISTING_SUCCESS,
  UPDATE_TEACHER_LISTING_ERROR,
  CREATE_TEACHER_LISTING_LOADING,
  CREATE_TEACHER_LISTING_SUCCESS,
  CREATE_TEACHER_LISTING_ERROR
} from 'actions/Teacher/listingActions';

import {
  TIMEZONES_LOADING,
  TIMEZONES_SUCCESS,
  TIMEZONES_ERROR
} from 'actions/Teacher/timezoneActions';

const INITIAL_STATE = {
  teacher: {},
  teacherStatus: 'INIT',
  updateTeacherStatus: 'INIT',

  // reservations
  reservations: [],
  reservationsStatus: 'INIT',
  rescheduleStatus: 'INIT',
  cancelStatus: 'INIT',

  // ongoing availability
  availability: {},
  availabilityStatus: 'INIT',
  setAvailabilityStatus: 'INIT',

  // specific availability
  blocks: [],
  teacherCreatedBlocks: [],
  calendarCreatedBlocks: [],
  blockError: null,
  createdBlockId: null,
  getBlockStatus: 'INIT',
  createBlockStatus: 'INIT',
  updateBlockStatus: 'INIT',
  deleteBlockStatus: 'INIT',

  // listings
  listing: {},
  listings: [],
  getListingStatus: 'INIT',
  getListingsStatus: 'INIT',
  updateListingStatus: 'INIT',

  // timezones
  timezones: null
};

export default function teacherReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESCHEDULE_TEACHER_RESERVATION_LOADING:
      return {
        ...state,
        rescheduleStatus: 'LOADING'
      };
    case RESCHEDULE_TEACHER_RESERVATION_SUCCESS:
      return {
        ...state,
        rescheduleStatus: 'SUCCESS'
      };
    case RESCHEDULE_TEACHER_RESERVATION_ERROR:
      return {
        ...state,
        rescheduleStatus: 'FAIL'
      };
    case CANCEL_TEACHER_BOOKING_LOADING:
      return {
        ...state,
        cancelStatus: 'LOADING'
      };
    case CANCEL_TEACHER_BOOKING_SUCCESS:
      return {
        ...state,
        cancelStatus: 'SUCCESS'
      };
    case CANCEL_TEACHER_BOOKING_ERROR:
      return {
        ...state,
        cancelStatus: 'FAIL'
      };
    case TEACHER_AVAILABILITY_LOADING:
      return {
        ...state,
        availabilityStatus: 'LOADING'
      };
    case TEACHER_AVAILABILITY_SUCCESS:
      return {
        ...state,
        availability: action.payload.data.data,
        availabilityStatus: 'SUCCESS'
      };
    case TEACHER_AVAILABILITY_ERROR:
      return {
        ...state,
        availability: {},
        availabilityStatus: 'FAIL'
      };
    case SET_TEACHER_AVAILABILITY_LOADING:
      return {
        ...state,
        setAvailabilityStatus: 'LOADING'
      };
    case SET_TEACHER_AVAILABILITY_SUCCESS:
      return {
        ...state,
        availability: action.payload,
        setAvailabilityStatus: 'SUCCESS'
      };
    case SET_TEACHER_AVAILABILITY_ERROR:
      return {
        ...state,
        setAvailabilityStatus: 'FAIL'
      };
    case GET_TEACHER_BLOCKS_LOADING:
      return {
        ...state,
        getBlockStatus: 'LOADING'
      };
    case GET_TEACHER_BLOCKS_SUCCESS:
      return {
        ...state,
        blocks: action.payload.data.data,
        getBlockStatus: 'SUCCESS'
      };
    case GET_TEACHER_BLOCKS_ERROR:
      return {
        ...state,
        getBlockStatus: 'FAIL'
      };
    case GET_TEACHER_CREATED_BLOCKS_LOADING:
      return {
        ...state,
        getBlockStatus: 'LOADING'
      };
    case GET_TEACHER_CREATED_BLOCKS_SUCCESS:
      return {
        ...state,
        teacherCreatedBlocks: action.payload.data.data,
        getBlockStatus: 'SUCCESS'
      };
    case GET_TEACHER_CREATED_BLOCKS_ERROR:
      return {
        ...state,
        getBlockStatus: 'FAIL'
      };
    case GET_CALENDAR_CREATED_BLOCKS_LOADING:
      return {
        ...state,
        getBlockStatus: 'LOADING'
      };
    case GET_CALENDAR_CREATED_BLOCKS_SUCCESS:
      return {
        ...state,
        calendarCreatedBlocks: action.payload.data.data,
        getBlockStatus: 'SUCCESS'
      };
    case GET_CALENDAR_CREATED_BLOCKS_ERROR:
      return {
        ...state,
        getBlockStatus: 'FAIL'
      };
    case CREATE_TEACHER_BLOCK_LOADING:
      return {
        ...state,
        blockError: null,
        createBlockStatus: 'LOADING'
      };
    case CREATE_TEACHER_BLOCK_SUCCESS:
      return {
        ...state,
        teacherCreatedBlocks: _.orderBy(
          [...state.teacherCreatedBlocks, action.payload.data.data],
          ['id'],
          ['desc']
        ),
        createBlockStatus: 'SUCCESS',
        createdBlockId: action.payload.data.data.id
      };
    case CREATE_TEACHER_BLOCK_ERROR:
      return {
        ...state,
        blockError: _.get(action.payload, 'response.data.error', 'Something went wrong'),
        createBlockStatus: 'FAIL'
      };
    case UPDATE_TEACHER_BLOCK_LOADING:
      return {
        ...state,
        blockError: null,
        updateBlockStatus: 'LOADING'
      };
    case UPDATE_TEACHER_BLOCK_SUCCESS:
      return {
        ...state,
        blocks: _.orderBy(_.unionBy([action.payload.data], state.blocks, 'id'), ['id'], ['desc']),
        updateBlockStatus: 'SUCCESS'
      };
    case UPDATE_TEACHER_BLOCK_ERROR:
      return {
        ...state,
        blockError: _.get(action.payload, 'response.data.error', 'Something went wrong'),
        updateBlockStatus: 'FAIL'
      };
    case DELETE_TEACHER_BLOCK_LOADING:
      return {
        ...state,
        deleteBlockStatus: 'LOADING'
      };
    case DELETE_TEACHER_BLOCK_SUCCESS:
      return {
        ...state,
        blocks: _.reject(state.blocks, { id: action.payload.id }),
        deleteBlockStatus: 'SUCCESS'
      };
    case DELETE_TEACHER_BLOCK_ERROR:
      return {
        ...state,
        deleteBlockStatus: 'FAIL'
      };
    case GET_TEACHER_LISTINGS_LOADING:
      return {
        ...state,
        getListingsStatus: 'LOADING'
      };
    case GET_TEACHER_LISTINGS_SUCCESS:
      return {
        ...state,
        listings: action.payload,
        getListingsStatus: 'SUCCESS'
      };
    case GET_TEACHER_LISTINGS_ERROR:
      return {
        ...state,
        getListingsStatus: 'FAIL'
      };
    case GET_TEACHER_LISTING_LOADING:
      return {
        ...state,
        getListingStatus: 'LOADING'
      };
    case GET_TEACHER_LISTING_SUCCESS:
      return {
        ...state,
        listing: action.payload,
        getListingStatus: 'SUCCESS'
      };
    case GET_TEACHER_LISTING_ERROR:
      return {
        ...state,
        getListingStatus: 'FAIL'
      };
    case UPDATE_TEACHER_LISTING_LOADING:
      return {
        ...state,
        updateListingStatus: 'LOADING'
      };
    case UPDATE_TEACHER_LISTING_SUCCESS:
      return {
        ...state,
        listing: action.payload,
        updateListingStatus: 'SUCCESS'
      };
    case UPDATE_TEACHER_LISTING_ERROR:
      return {
        ...state,
        updateListingStatus: 'FAIL'
      };
    case CREATE_TEACHER_LISTING_LOADING:
      return {
        ...state,
        createListingStatus: 'LOADING'
      };
    case CREATE_TEACHER_LISTING_SUCCESS:
      return {
        ...state,
        listing: action.payload,
        createListingStatus: 'SUCCESS'
      };
    case CREATE_TEACHER_LISTING_ERROR:
      return {
        ...state,
        createListingStatus: 'FAIL'
      };
    case TIMEZONES_LOADING:
      return {
        ...state,
        timezonesStatus: 'LOADING'
      };
    case TIMEZONES_SUCCESS:
      return {
        ...state,
        timezonesStatus: 'SUCCESS',
        timezones: action.payload
      };
    case TIMEZONES_ERROR:
      return {
        ...state,
        timezonesStatus: 'FAIL'
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Teacher/teacherReducer.js